export const formatValueWithSpace = (value: number) =>
  new Intl.NumberFormat('sv-SE', {
    useGrouping: true,
    minimumFractionDigits: 0,
  }).format(value)
